import React, { useRef } from "react";
import { useGridApiContext } from "@mui/x-data-grid";
import Field from "@hyro-components/fields/HyroField";

const EditableMetricCell = ({
  id,
  field,
  value,
  min = 0,
  max,
  errorMessage,
  helperText,
  onCommit
}) => {
  const apiRef = useGridApiContext();
  const currentValueRef = useRef(value);
  const numValue = Number(value);
  const isError = value !== "" && (isNaN(numValue) || numValue < min || numValue > max);

  const commitEdit = () => {
    const val = currentValueRef.current;
    const num = Number(val);
    if (val !== "" && !isNaN(num) && num >= min && num <= max) {
      onCommit(num);
    }
    apiRef.current.stopCellEditMode({ id, field });
  };

  return (
    <Field
      autoFocus
      value={String(value)}
      error={isError ? errorMessage : undefined}
      showErrorInPopper
      helperText={helperText}
      formHelperProps={{ sx: { ml: 0 } }}
      sx={{ paddingTop: "18px" }}
      InputProps={{ sx: { fontSize: "14px" } }}
      onChange={(newValue) => {
        if (newValue !== "" && !/^\d+$/.test(newValue)) return;
        const parsed = newValue === "" ? "" : Number(newValue);
        currentValueRef.current = parsed;
        apiRef.current.setEditCellValue({ id, field, value: parsed });
      }}
      onBlur={commitEdit}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          event.preventDefault();
          event.target.blur();
        }
        if (event.key === "Escape") {
          event.preventDefault();
          apiRef.current.stopCellEditMode({ id, field, ignoreModifications: true });
        }
        if (event.key === "Tab") {
          event.preventDefault();
        }
      }}
    />
  );
};

export default EditableMetricCell;
